import { revenue } from '../content.js'
import Icon from '../components/Icon.jsx'

export default function Revenue() {
  return (
    <section className="section" id="sell">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{revenue.eyebrow}</span>
          <h2>{revenue.title}</h2>
        </div>
        <div className="cards">
          {revenue.items.map((it) => (
            <article key={it.title} className="card">
              <div className="card-icon tone-rose"><Icon name={it.icon} /></div>
              <h3>{it.title}</h3>
              <p>{it.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
